export default {"src":"/_next/static/media/features_dots.482b192c.svg","height":429,"width":419,"blurWidth":0,"blurHeight":0};